<div class="auth-fullpage">
  <div id="logo-container" [@fadeInGlideUp]="authService.animationDuration">
    <app-logo width="217px" height="48px" class="svg-bold"></app-logo>
  </div>

  <div id="component-container" class="position-relative" [@fadeInGlideDown]="authService.animationDuration">
    <c-card id="component-view-port" class="w-30 p-3 position-absolute top-50 start-50 translate-middle-x">
      <c-card-body>
        <app-form-header
          [parentComponent]="this"
          [icon]="icons.bAdguard"
          [title]="'AUTH_RESET_PASSWORD_HEADER'"
          [content]="'AUTH_RESET_PASSWORD_HEADER_TEXT'"
        ></app-form-header>
        @if (!authService.actionSucceeded(this)) {
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <app-control-input-password
              formControlName="newPassword1"
              [placeholder]="'AUTH_RESET_PASSWORD_PLACEHOLDER_PASSWORD'"
              (userKeyup)="authService.onPasswordChange(this)"
            >
            </app-control-input-password>
            <app-control-input-password
              formControlName="newPassword2"
              [placeholder]="'AUTH_RESET_PASSWORD_PLACEHOLDER_CONFIRM'"
              (userKeyup)="authService.onPasswordChange(this)"
            >
            </app-control-input-password>
            <app-control-button-submit
              [parentComponent]="this"
              [buttonText]="'AUTH_RESET_PASSWORD_BUTTON'"
              [disabled]="authService.submitButtonIsDisabled(this)"
              [icon]="icons.pencil"
            ></app-control-button-submit>
            <c-input-group class="d-grid gap-2 flex-nowrap p-2">
              <app-alert-message [parentComponent]="this"></app-alert-message>
            </c-input-group>
          </form>
        }
        @if (authService.actionSucceeded(this)) {
          <c-container>
            <app-alert-confirmation
              [parentComponent]="this"
              [message]="'AUTH_RESET_PASSWORD_MESSAGE_SUCCESS'"
            ></app-alert-confirmation>
            <app-control-button-submit
              [parentComponent]="this"
              (click)="authService.navigateTo('/login')"
              [buttonText]="'AUTH_RESET_PASSWORD_BUTTON_BACK_TO_LOGIN'"
              [icon]="icons.actionRedo"
              [iconRotation]="180"
            ></app-control-button-submit>
          </c-container>
        }
      </c-card-body>
    </c-card>
  </div>
</div>
